import { Component } from '@angular/core';

@Component({
    selector: 'app-middle-single-container',
    imports: [],
    templateUrl: './middle-single-container.component.html',
    styleUrl: './middle-single-container.component.scss'
})
export class MiddleSingleContainerComponent {
    
}
